module.exports = __webpack_public_path__ + "assets/overlay-right-side.0cb41b2998448f576b8a889692a1889d.png";